import ImageDataManager from './ImageDataManager';
import themeColors from './data/themeColors.json';

export default class ThemeSection {
  constructor(background, gridLarge, gridSmall, requestOnceDrawMainCanvas) {
    const elThemeSection = document.querySelector('#themeSection');
    const elThemeSelector = elThemeSection.querySelector('.theme');
    for(const key in themeColors) {
      const option = document.createElement('option');
      option.value = key;
      option.textContent = key;
      const group = themeColors[key].group;
      for(const optGroup of elThemeSelector.children) {
        if(optGroup.dataset.name === group) {
          optGroup.appendChild(option);
        }
      }
    }
    elThemeSelector.firstElementChild.firstElementChild.selected = true;
    elThemeSelector.addEventListener('input', () => {
      const themeColor = themeColors[elThemeSelector.value];
      const colors = themeColor.colors;
      for(const key in colors) {
        const value = colors[key];
        document.documentElement.style.setProperty('--color-' + key, value);
      }
      background.set(themeColor.type, themeColor.props);
      updateCheckerBackground(colors);
      gridLarge.strokeStyle = gridSmall.strokeStyle = colors['frame'];
      requestOnceDrawMainCanvas();
    });
    function updateCheckerBackground(colors) {
      if(!colors) {
        const style = getComputedStyle(document.documentElement);
        colors = {
          background: style.getPropertyValue('--color-background'),
          background2: style.getPropertyValue('--color-background2'),
        };
      }
      document.documentElement.style.setProperty('--url-checker', `url("data:image/svg+xml,${encodeURIComponent(`<svg width="16" height="16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <rect x="0" y="0" width="8" height="8" fill="${colors.background}"/>
        <rect x="8" y="0" width="8" height="8" fill="${colors.background2}"/>
        <rect x="0" y="8" width="8" height="8" fill="${colors.background2}"/>
        <rect x="8" y="8" width="8" height="8" fill="${colors.background}"/>
        ${ImageDataManager.canvasBackground ? `<rect x="0" y="0" width="16" height="16" fill="${ImageDataManager.canvasBackground}"/>` : ''}
      </svg>`)}")`);
    }
    elThemeSection.querySelector('.canvas').addEventListener('input', e => {
      ImageDataManager.canvasBackground = e.target.value;
      updateCheckerBackground();
      requestOnceDrawMainCanvas();
    });
    elThemeSection.querySelector('.static > input').addEventListener('input', e => {
      background.setStatic(e.target.checked);
    });
    let themeSectionTimeoutID = 0;
    elThemeSection.addEventListener('mouseenter', () => {
      clearInterval(themeSectionTimeoutID);
      elThemeSection.classList.add('hover');
    });
    elThemeSection.addEventListener('mouseleave', () => {
      themeSectionTimeoutID = setTimeout(() => {
        elThemeSection.classList.remove('hover');
      }, 1000);
    });
  }
}
